import { Person, Restaurant } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { route } from '@/constants/routeName';

export default function ParentAppChrome() {
	const accountType = useSelector((state) => state.auth.accountType);
	const user = useSelector((state) => state.auth.user);
	if (accountType !== 'parent') return null;

	const parentName = user?.name || 'Parent';

	return (
		<header className='brand'>
			<div className='wordmark'>
				<Restaurant fontSize='small' aria-hidden='true' />
				<span>
					Jungle Toppings
					<small>Parent app</small>
				</span>
			</div>
			<Link
				to={`/${route.account}`}
				className='brand-account'
				aria-label={`Family account, ${parentName}`}
			>
				<span className='brand-parentname'>{parentName}</span>
				<span className='profile' aria-hidden='true'>
					<Person fontSize='small' />
				</span>
			</Link>
		</header>
	);
}
